"use client"

import { Controller, FieldPath, FieldValues, useFormContext } from "react-hook-form"
import { FormControl, FormItem } from "../../ui/shadcn/form"
import { Switch } from "../../ui/shadcn/switch"
import { DynamicFormLabel } from "../components/form-label"
import type { ParsedField } from "../types"

interface BooleanFieldProps {
	field: ParsedField
}

export function BooleanField({ field: parsedField }: BooleanFieldProps) {
	const { name, schema, required } = parsedField
	const description = schema.description
	const title = schema.title
	const { control } = useFormContext()
	const defaultValue = schema.default !== undefined ? (schema.default as boolean) : false

	return (
		<Controller
			name={name as FieldPath<FieldValues>}
			control={control}
			render={({ field }) => (
				<FormItem className="h-10 bg-g800/10 rounded-lg px-3 flex items-center justify-between group">
					<DynamicFormLabel name={name} title={title} required={required} description={description} />
					<FormControl>
						<Switch checked={field.value ?? defaultValue} onCheckedChange={field.onChange} />
					</FormControl>
				</FormItem>
			)}
		/>
	)
}
